import {
  getDriverFuzzyList as getDriverFuzzyListApi,
  driverAdd as driverAddApi,
  getDriverList as getDriverListApi,
  getDriverTeamFuzzyList as getDriverTeamFuzzyListApi,
  getDriverDetail as getDriverDetailApi,
  getAssignedLoadsList as getAssignedLoadsListApi,
  editProfile as editProfileApi,
  changeStatus as changeStatusApi,
  getDriverMapList as getDriverMapListApi,
  getDriverActivityList as getDriverActivityListApi,
  getProfile as getProfileApi,
  getAvailable as getAvailableApi,
  checkUserInfo as checkUserInfoApi,
  getDriverTeamList as getDriverTeamListApi,
  getPaymentTermsList,
  getDriverData as getDriverDataApi,
  getDriverTeamDetail as getDriverTeamDetailApi,
  getPaymentTermListByDriverId as getPaymentTermListByDriverIdAPI,
  updateDriverTeam as updateDriverTeamApi,
  activeOrInactiveDriverTeam as activeOrInactiveDriverTeamApi,
  deleteDriverTeam as deleteDriverTeamApi,
} from "@/api/driver";
import { getConfigBasic } from "@/api/common";
import {
  getAddressAutosuggest as getAddressAutosuggestApi,
  getAddressDetail as getAddressDetailApi,
} from "@/api/search";
import orderBy from "lodash/orderBy";
import { combiningStrings } from "@/tools/basic-methods";
import store from "@/store";
import { systemInfo } from "@/shared-services";
import { noPermissionSettings } from "@/utils/permission";
import { DSPNoPermissionFilterItemFn, DSPFilterNoPermissionIdFn } from "@/utils/permission";
const state = {
  namespaced: true,
  state: {
    driverTeamDetail:[],
    driverData:[],
    terminalListData: [],
    driverTeamListData: [],
    driverTeamListTotal: 0,
    driverTeamMapListData: [],
    driverListData: [],
    driverFuzzyListData: [],
    driverMapListData: [],
    driverMapListDataStatus: true,
    driverListTotal: 0,
    currentPage: 1, // 当前页
    pageSize: 20, // 每页的数量
    driverListStatus: "Active", // 状态筛选 All、Active、Inactive
    driverListRequestStatus: false, // terminalListData 用户列表是否请求完成
    tableLoading: false,
    driverDetailData: {},
    assignedLoadsList: [],
    profileData: [],
    driverActivityListData: [],
    availableTotal: 0,
    driverSearchParams: {
      blurry: "",
      groupIds: [],
      predefinedType: 1,
      sortAs: "ASC",
      sortBy: "id",
      workStatus: [],
      accountStatus: [],
      ownerIds:[],
      page: 0,
      size: 15,
      companyIds: [],
    },
    assignedLoadSearchParams: {
      search: "",
      driverId: "",
      customerName: "",
      deliveryTime: [],
      equipType: [],
      pickupTime: [],
      statusWeb: [],
      sortBy: "price",
      sortAs: "DESC",
      type: 0,
    },
    paymentTermsLoad: false,
    paymentTerms: {
      loadRateTerms: [],
      payTerms: [],
      deductionTerms: [],
      type: [],
      periodTimeArray: [],
    },
  },
  mutations: {
    SET_TERMINAL_LIST(state, list) {
      state.terminalListData = list;
    },
    SET_TABLE_LOADING(state, flag) {
      state.tableLoading = flag;
    },
    SET_ASSIGNED_LOADS_LIST(state, list) {
      state.assignedLoadsList = list;
    },
    SET_PROFILE_DATA(state, list) {
      state.profileData = list;
    },
    SET_DRIVER_LIST(state, list) {
      state.driverListData = list;
    },    
    SET_DRIVER_FUZZY_LIST(state, list) {
      state.driverFuzzyListData = list;
    },
    SET_DRIVER_LIST_WS(state, params = []) {
      state.driverListData && state.driverListData.forEach(item => {
        let obj = params.find(it => it.driverId === item.driverId)
        if (obj) {
          item.lastKnownLocation = obj.lastKnownLocation
        } 
      })
    },
    SET_DRIVER_MAP_LIST(state, list) {
      state.driverMapListData = list;
    },
    SET_DRIVER_MAP_LIST_STATUS(state, flag) {
      state.driverMapListDataStatus = flag;
    },
    SET_DRIVER_ACTIVE_LIST(state, list) {
      state.driverActivityListData = list;
    },
    SET_DRIVER_DETAILS_LIST(state, list) {
      state.driverDetailData = list;
    },
    SET_DRIVER_DETAILS_WS(state, params = {}) {
      if (state.driverDetailData) {
        if (!state.driverDetailData.hos) {
          state.driverDetailData.hos = {}
        }
        state.driverDetailData.hos.timeRemainingBreak =  params.timeRemainingBreak
        state.driverDetailData.hos.driveRemainingDuration =  params.driveRemainingDuration
        state.driverDetailData.hos.shiftRemainingDuration =  params.shiftRemainingDuration
        state.driverDetailData.hos.cycle =  params.cycle
        state.driverDetailData.hos.cycleRule =  params.cycleRule
        state.driverDetailData.hos.cycleLeftToday =  params.cycleLeftToday
        state.driverDetailData.hos.cycleLeftTomorrow =  params.cycleLeftTomorrow
        state.driverDetailData.basicInfo.connectELD =  true
      }
    },
    SET_DRIVER_LIST_REQUEST_STATUS(state, status) {
      state.driverListStatus = status;
    },
    SET_DRIVER_LIST_TOTAL(state, total) {
      state.driverListTotal = total;
    },
    SET_CURRENT_PAGE(state, currentPage) {
      state.currentPage = currentPage;
    },
    SET_PAGE_SIZE(state, pageSize) {
      state.pageSize = pageSize;
    },
    SET_DRIVER_LIST_STATUS(state, status) {
      state.driverListStatus = status;
    },
    SET_DRIVER_SEARCH_PARAMS(state, params) {
      state.driverSearchParams = params;
    },
    SET_ASSIGNED_LOAD_SEARCH_PARAMS(state, params) {
      state.assignedLoadSearchParams = params;
    },
    SET_AVAILABLE_TOTAL(state, params) {
      state.availableTotal = params;
    },
    INIT_DRIVER_LIST_STATE(state) {
      state.terminalListTotal = 0;
      state.currentPage = 1;
      state.pageSize = 20;
      state.terminalListStatus = false;
    },
    SET_PAYMENT_TERMS(state, payload) {
      state.paymentTerms = Object.assign({}, payload);
    },
    SET_PAYMENT_LOAD(state, payload) {
      state.paymentTermsLoad = payload;
    },
    SET_DRIVER_TEAM_LIST(state, list) {
      state.driverTeamListData = list;
    },
    SET_DRIVER_TEAM_LIST_TOTAL(state, total) {
      state.driverTeamListTotal = total;
    },
    SET_DRIVER_TEAMMAP_LIST(state, list) {
      state.driverTeamMapListData = list;
    },
    SET_DRIVER_DATA(state, list) {
      state.driverData = list;
    },
    SET_DRIVER_TEAM_DETAIL(state, list){
      state.driverTeamDetail = list;
    }
  },
  actions: {
    updateDriverListByWs({commit }, params) {
      commit('SET_DRIVER_LIST_WS', params)
    },
    updateDriverDetailByWs({commit }, params) {
      commit('SET_DRIVER_DETAILS_WS', params)
    },
    updateDriverListStatus({ commit }, status) {
      commit("SET_TERMINAL_LIST_STATUS", status);
    },
    updatePageSize({ commit }, pageSize) {
      commit("SET_PAGE_SIZE", pageSize);
    },
    updateCurrentPage({ commit }, currentPage) {
      commit("SET_CURRENT_PAGE", currentPage);
    },
    getTerminalListData({ commit }) {
      return getConfigBasic().then(
        (result) => {
          try {
            if (result.code == 200) {
              let members = result.data.driver_terminal || [];
              for (let item of members) {
                item.label = item.terminalName;
                item.value = item.terminalId;
              }
              commit("SET_TERMINAL_LIST", members);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    getAddressSearch({ rootState }, { value }) {
      let api = getAddressAutosuggestApi;
      let { latitude: lat, longitude: lon } = rootState.inUseLocation;
      let params = { input: value, lat, lon };
      return api(params).then(
        (result) => {
          try {
            let data = result.res.data.data.map((item) => {
              item.value = item.title;
              item.unifiedTitle = item.highlightedTitle || item.title;
              item.pointType = item.isFacility ? "facility" : "address";
              item.latitude = item.position[0];
              item.longitude = item.position[1];
              item.facilityId = item.facilityId || null;
              return item;
            });
            return orderBy(data.slice(0, 5), ["isFacility", "asc"]);
          } catch (error) {
            return [];
          }
        },
        () => {
          return [];
        }
      );
    },
    getAddressDetail(context, info) {
      let params = {
        context: info.context,
        id: info.id,
      };
      return getAddressDetailApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            let bbox = data.bbox;
            let category = data.category;
            let title = data.name;
            let location = data.location;
            let position = location.position;
            let latitude = position[0];
            let longitude = position[1];
            let address = location.address;
            let postalCode = address.postalCode;
            let city = address.city;
            let country = address.country;
            let countryCode = address.countryCode;
            let county = address.county;
            let state = address.state;
            let stateCode = address.stateCode;
            let locationInfo = combiningStrings([
              city,
              stateCode,
              postalCode,
              countryCode,
            ]);
            let resultInfo = {
              bbox,
              category,
              latitude,
              longitude,
              postalCode,
              city,
              country,
              title,
              countryCode,
              county,
              state,
              stateCode,
              locationInfo,
              pointType: "address",
              info: data,
            };
            return resultInfo;
          } catch (error) {
            console.log(error);
            return null;
          }
        },
        (error) => {
          console.log(error);
          return null;
        }
      );
    },
    addDriverListData({ commit }, params) {
      return driverAddApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            console.log(data);
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TERMINAL_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_TERMINAL_LIST_REQUEST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    // 修改driverList搜索条件
    setDriverSearchParams({ state, commit }, data) {
      if (data) {
        const obj = Object.assign({}, state.driverSearchParams);
        obj.blurry = data.activTabsId === 'Team'?(data.search || ""):(data.search || "").replace(/\s/g, "");
        obj.groupIds = data.terminalSeletChooseValue;
        obj.workStatus = data.driverStatus;
        obj.predefinedType = data.predefinedType;
        obj.accountStatus = data.accountStatus;
        obj.ownerIds = data.ownerId;
        obj.status = data.status;
        obj.driverTypes=data.driverType
        if(!systemInfo.isCommand) {
          if(data.activTabsId === 'Team') {
            if(data.companyIds && data.companyIds.length) {
              obj.fleetCompanyIds = data.companyIds && data.companyIds.join(",") || '';
            } else {
              obj.fleetCompanyIds = ''
            }
          } else {
            obj.companyIds = data.companyIds;
          }
        }
        commit("SET_DRIVER_SEARCH_PARAMS", obj);
      }
    },
    // 修改ASSIGNED LOAD搜索条件
    setAssignedLoadSearchParams({ state, commit }, data) {
      if (data) {
        const obj = Object.assign({}, state.assignedLoadSearchParams);
        obj.driverId = data.driverId / 1;
        obj.search = data.search;
        obj.customerName = data.customerName;
        obj.deliveryTime = data.deliveryTime;
        obj.pickupTime = data.pickupTime;
        obj.equipType = data.equipType;
        obj.type = data.type;
        obj.statusWeb = data.statusWeb;
        commit("SET_ASSIGNED_LOAD_SEARCH_PARAMS", obj);
      }
    },
    getDriverList({ state, commit }) {
      commit("SET_TABLE_LOADING", true);
      let parms = {
        ...state.driverSearchParams,
        page: state.currentPage - 1,
        size: state.pageSize
      }
      store.dispatch("user/getOnboardingStatus");
      return getDriverListApi(parms).then(
        (result) => {
          try {
            let data = result.res.data;
            if (data.code == 200 && data.message == "success") {
              console.log(result);
              let members = data.data.content || [];

              for (let item of members) {
                if(systemInfo.isCommand){
                  if (noPermissionSettings("fleet:business:accessCompanyDrivers",item.ownerId) || noPermissionSettings("fleet:carrierBusiness:accessCreateByDispatcher",'',item.systemSource)) {
                    item.noPermission = true;
                    item.commandDisabled = true;
                  }
                } else {
                  if ((DSPNoPermissionFilterItemFn("dispatcher:business:accessCarrierEntities") && DSPFilterNoPermissionIdFn(item.dispatcherId)) || item.systemSource === 'fleet') {
                    item.noPermission = true;
                    item.commandDisabled = true;
                  }
                }
                item.name = item.name.trim();
                if (item.status) {
                  let value = "",
                    label = "";
                  switch (item.status) {
                    case "inactive":
                      value = "0";
                      label = "Inactive";
                      break;
                    case "active":
                      value = "2";
                      label = "Active";
                      break;
                    case "in_transit":
                      value = "3";
                      label = "In Transit";
                      break;
                    case "Available":
                      value = "6";
                      label = "Available";
                      break;
                    case "Time Off":
                      value = "7";
                      label = "Time Off";
                      break;
                  }

                  item.status = {
                    value: value,
                    label: label,
                  };
                } else {
                  item.status = {
                    value: "",
                    label: "",
                  };
                }
                // if (!item.newDriverId || item.newDriverId == "null") {
                //   item.commandDisabled = true;
                // }
                if(systemInfo.isCommand){
                  item.checCheckboxkRenderObj = {
                    checCheckboxkRender: true,
                    checCheckboxkRenderFileName: "newDriverId",
                  };
                }
                
              }
              commit("SET_DRIVER_LIST", members);
              commit("SET_DRIVER_LIST_TOTAL", data.data.totalElements);
              commit("SET_TABLE_LOADING", false);
              return Promise.resolve(data);
            } else {
              commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
              commit("SET_TABLE_LOADING", false);
              return Promise.reject(data);
            }
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            commit("SET_TABLE_LOADING", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          commit("SET_TABLE_LOADING", false);
          return Promise.reject(error);
        }
      );
    },
    getDriverFuzzyList({ commit }){
      getDriverFuzzyListApi().then(
        (result) => {
        try {
          let data = result.res.data;
          if (data.code == 200 && data.message == "success") {
            let members = data.data || [];
            commit("SET_DRIVER_FUZZY_LIST", members);
            return Promise.resolve(data);
          }
          else
          return Promise.reject(data);
        } catch (error) {
          Promise.reject(error);
        }
      }).catch((item)=>{
        console.log('Inside driver all fuzzy list error:',item)
      })
    },
    getDriverTeamFuzzyList({ commit }){
      getDriverTeamFuzzyListApi().then(
        (result) => {
        try {
          let data = result.res.data;
          if (data.code == 200 && data.message == "success") {
            let members = data.data || [];
            commit("SET_DRIVER_FUZZY_LIST", members);
            return Promise.resolve(data);
          }
          else
          return Promise.reject(data);
        } catch (error) {
          Promise.reject(error);
        }
      }).catch((item)=>{
        console.log('Inside driver all fuzzy list error:',item)
      })
    },
    getDriverMapList({ state, commit }) {
      let parms = JSON.parse(JSON.stringify(state.driverSearchParams));
      commit("SET_DRIVER_MAP_LIST_STATUS", false);
      // parms.predefinedType = 0;
      return getDriverMapListApi(parms).then(
        (result) => {
          try {
            let data = result.res.data;
            if (data.code == 200 && data.message == "success") {
              let members = data.data || [];
              let membersFilterArr = members.filter((item) => {
                return (
                  item.status != "inactive" && item.latitude && item.longitude
                );
              });
              for (let item of membersFilterArr) {
                if (item.status === "Available") {
                  item.loadInfo = null;
                } else if (item.loadInfo) {
                  item.loadInfo.pickupTime = item.loadInfo.pickupTimeFromString;
                  item.loadInfo.deliveryTime =
                    item.loadInfo.deliveryTimeFromString;
                }
              }
              console.log(membersFilterArr, "membersFilterArr000");
              commit("SET_DRIVER_MAP_LIST", membersFilterArr);
              commit("SET_DRIVER_MAP_LIST_STATUS", true);
              return Promise.resolve(data);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          commit("SET_TABLE_LOADING", false);
          commit("SET_DRIVER_MAP_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    changeStatus({ commit }, params) {
      return changeStatusApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            console.log(data);
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    getDriverDetail({ commit }, params) {
      return getDriverDetailApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            if (data.code == 200) {
              let members = data.data || {};
              members.basicInfo.regisState = members.basicInfo.state?.[0];
              members.basicInfo.regisProvince = members.basicInfo.state?.[1];
              members.basicInfo.insuranceRegisState =
                members.basicInfo.icenseState?.[0];
              members.basicInfo.insuranceRegisProvince =
                members.basicInfo.licenseState?.[1];
              members.basicInfo.restrictions =
                members.basicInfo.restrictions || [];
              members.basicInfo.endorsement =
                members.basicInfo.endorsement || [];
              commit("SET_DRIVER_DETAILS_LIST", members);
            }
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    getDriverActivityList({ commit }, params) {
      return getDriverActivityListApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            if (data.code == 200 && data.message == "success") {
              console.log(data);
              let members = data.data || [];
              commit("SET_DRIVER_ACTIVE_LIST", members);
              return Promise.resolve(data);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getAssignedLoadsList({ state, commit }) {
      return getAssignedLoadsListApi(state.assignedLoadSearchParams).then(
        (result) => {
          try {
            let data = result.res.data;
            let members = data.data || {};
            for (let item of members) {
              if (item.status) {
                let value = "";
                switch (item.status) {
                  case "Completed":
                    value = "0";
                    break;
                  case "Pending":
                    value = "1";
                    break;
                  case "Accepted":
                    value = "2";
                    break;
                  case "In Transit":
                    value = "3";
                    break;
                  case "Rejected":
                    value = "4";
                    break;
                  case "Submitted":
                    value = "5";
                    break;
                  case "Unassigned":
                    value = "6";
                    break;
                  case "Delivered":
                    value = "7";
                    break;
                }
                item.status = {
                  value: value,
                  label: item.status,
                };
              }
            }
            console.log(data);
            commit("SET_ASSIGNED_LOADS_LIST", members);
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    editProfile({ commit }, params) {
      return editProfileApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            console.log(data);
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    getAvailable({ commit }, params) {
      // if (systemInfo.isCommand) {
      console.log(commit, params, getAvailableApi)
      return Promise.resolve(1000000)
      // }
      // return getAvailableApi(params).then(
      //   (result) => {
      //     try {
      //       let data = result.res.data;
      //       console.log(data);
      //       let members = data.data.available || 0;
      //       commit("SET_AVAILABLE_TOTAL", members);
      //       return Promise.resolve(data);
      //     } catch (error) {
      //       commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
      //       return Promise.reject(error);
      //     }
      //   },
      //   (error) => {
      //     commit("SET_DRIVER_LIST_STATUS", false);
      //     return Promise.reject(error);
      //   }
      // );
    },
    getProfile({ commit }, params) {
      return getProfileApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            console.log(data);
            let members = data.data || [];
            commit("SET_PROFILE_DATA", members);
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    checkEmail(content, parms) {
      return checkUserInfoApi(parms).then((res) => {
        return res.res.data.data;
      });
    },
    initTerminalListInfo({ commit }) {
      commit("INIT_TERMINAL_LIST_STATE");
    },
    async getPaymentTerms({ commit }, driverId) {
      commit("SET_PAYMENT_LOAD", true);
      let { res } = await getPaymentTermsList(driverId);
      let data = res.data.data;
      console.log(data);
      data.type = data.type.map((item) => {
        return {
          label: item,
          value: item,
        };
      });
      data.teamType = data.teamType.map((item) => {
        return {
          label: item,
          value: item,
        };
      });
      data.periodTimeArray = data.periodTimeArray.map((item) => {
        let str = item[0] + item.slice(1).toLowerCase();
        return {
          label: str,
          value: str,
        };
      });
      commit("SET_PAYMENT_TERMS", data);
      commit("SET_PAYMENT_LOAD", false);
    },
    getDriverTeamList({ state, commit }) {
      commit("SET_TABLE_LOADING", true);
      let obj = JSON.parse(JSON.stringify(state))
      let parms = {
        ...obj.driverSearchParams,
        page: obj.currentPage - 1,
        size: obj.pageSize,
        status: obj.driverSearchParams.status?.join(',')
      }
      store.dispatch("user/getOnboardingStatus");
      return getDriverTeamListApi(parms).then(
        (result) => {
          try {
            let data = result.res.data;
            if (data.code == 200 && data.message == "success") {
              let members = data.data.data || [];

              for (let item of members) {
                if (item.status) {
                  let value = "",
                    label = "";
                  switch (item.status) {
                    case "Inactive":
                      value = "0";
                      label = "Inactive";
                      break;
                    case "In Transit":
                      value = "3";
                      label = "In Transit";
                      break;
                    case "Available":
                      value = "6";
                      label = "Available";
                      break;
                    case "Time Off":
                      value = "7";
                      label = "Time Off";
                      break;
                  }

                  item.status = {
                    value: value,
                    label: label,
                  };
                } else {
                  item.status = {
                    value: "",
                    label: "",
                  };
                }
                // if (!item.newDriverId || item.newDriverId == "null") {
                //   item.commandDisabled = true;
                // }
                item.checCheckboxkRenderObj = {
                  checCheckboxkRender: true,
                  checCheckboxkRenderFileName: "newDriverId",
                };
              }
              commit("SET_DRIVER_TEAM_LIST", members);
              commit("SET_DRIVER_TEAM_LIST_TOTAL", data.data.total);
              commit("SET_TABLE_LOADING", false);
              return Promise.resolve(data);
            }
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            commit("SET_TABLE_LOADING", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          commit("SET_TABLE_LOADING", false);
          return Promise.reject(error);
        }
      );
    },
    getDriverData({commit},params){
      return getDriverDataApi(params).then((result)=>{
        commit("")
        return Promise.resolve(result.res.data);
      })
    },
    getDriverTeamDetail({ commit }, params) {
      
      return getDriverTeamDetailApi(params).then(
        (result) => {
          try {
            let data = result.res.data;
            if (data.code == 200) {
              let members = data.data || {};

              // members.basicInfo.regisState = members.basicInfo.state?.[0];
              // members.basicInfo.regisProvince = members.basicInfo.state?.[1];
              // members.basicInfo.insuranceRegisState =
              //   members.basicInfo.icenseState?.[0];
              // members.basicInfo.insuranceRegisProvince =
              //   members.basicInfo.licenseState?.[1];
              // members.basicInfo.restrictions =
              //   members.basicInfo.restrictions || [];
              // members.basicInfo.endorsement =
              //   members.basicInfo.endorsement || [];
              commit("SET_DRIVER_TEAM_DETAIL", members);
            }
            return Promise.resolve(data);
          } catch (error) {
            commit("SET_TRUCKS_LIST_REQUEST_STATUS", false);
            return Promise.reject(error);
          }
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    getPaymentTermListByDriverId({ commit }, params) {
      return getPaymentTermListByDriverIdAPI(params).then(
        (result) => {
            let data = result.res.data;
            if (data.code == 200) {
              // let members = data.data || {};
              // commit("SET_DRIVER_TEAM_DETAIL", members);
            }
            return Promise.resolve(data);
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },

    updateDriverTeam({ commit }, params) {
      return updateDriverTeamApi(params).then(
        (result) => {
          const data = result.res.data;
          if(data.code === 500){
            commit("SET_DRIVER_LIST_STATUS", false);
            return Promise.reject(data)
          }
          return Promise.resolve(data);
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    deleteDriverTeam({ commit }, params) {
      return deleteDriverTeamApi(params).then(
        (result) => {
          const data = result.res.data;
          if(data.code === 500){
            commit("SET_DRIVER_LIST_STATUS", false);
            return Promise.reject(data)
          }
          return Promise.resolve(data);
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    activeOrInactiveDriverTeam({ commit }, params) {
      return activeOrInactiveDriverTeamApi(params).then(
        (result) => {
          const data = result.res.data;
          if(data.code === 500){
            commit("SET_DRIVER_LIST_STATUS", false);
            return Promise.reject(data)
          }
          return Promise.resolve(data);
        },
        (error) => {
          commit("SET_DRIVER_LIST_STATUS", false);
          return Promise.reject(error);
        }
      );
    },
    updateDriverDetail({ commit }, info) {
      commit('SET_DRIVER_DETAILS_LIST', info)
    }
  },
  getters: {
    terminalListData: (state) => state.terminalListData,
    driverListData: (state) => state.driverListData,
    driverFuzzyListData: (state) => state.driverFuzzyListData,
    driverListTotal: (state) => state.driverListTotal,
    currentPage: (state) => state.currentPage,
    pageSize: (state) => state.pageSize,
    driverSearchParams: (state) => state.driverSearchParams,
    driverListStatus: (state) => state.driverListStatus,
    driverListRequestStatus: (state) => state.driverListRequestStatus,
    tableLoading: (state) => state.tableLoading,
    driverDetailData: (state) => state.driverDetailData,
    assignedLoadsList: (state) => state.assignedLoadsList,
    profileData: (state) => state.profileData,
    assignedLoadSearchParams: (state) => state.assignedLoadSearchParams,
    driverMapListData: (state) => state.driverMapListData,
    driverActivityListData: (state) => state.driverActivityListData,
    availableTotal: (state) => state.availableTotal,
    driverMapListDataStatus: (state) => state.driverMapListDataStatus,
    driverTeamListData: (state) => state.driverTeamListData,
    driverTeamListTotal: (state)=> state.driverTeamListTotal,
    driverTeamMapListData: (state) => state.driverTeamMapListData,
    driverData: (state) => state.driverData,
    driverTeamDetail: (state) => state.driverTeamDetail,
  },
};

export default state;
